import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateSupplierRate = (frameworkAgreementId, lotId, facId, values) => {
  return axios.put(
    `/api/framework_agreements/${frameworkAgreementId}/setup/lots/${lotId}/rates/suppliers/${facId}`,
    values
  );
};

export const useUpdateSupplierRate = (frameworkAgreementId, lotId, facId) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => updateSupplierRate(frameworkAgreementId, lotId, facId, values),
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
